export default __webpack_public_path__ + "static/media/transfer-internal.50241a70.png";